import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'components/AuthGuard';
// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const QuanLyKhachHang = Loadable(lazy(() => import('pages/quanly/page-quanlykhachhang')));
const QuanLyKhuVuc = Loadable(lazy(() => import('pages/quanly/page-quanlykhuvuc')));
const NhapDuLieu = Loadable(lazy(() => import('pages/nhapxuat/page-nhapdulieucan')));
const XuatDuLieu = Loadable(lazy(() => import('pages/nhapxuat/page-quanlyinphieu')));
const QuanLyNguoiDung = Loadable(lazy(() => import('pages/quanly/page-quanlynguoidung')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: 
  <AuthGuard>
      <DashboardLayout />
    </AuthGuard>,
  children: [
    {
      path: '/',
      element: <NhapDuLieu />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'quanlykhachhang',
      element: <QuanLyKhachHang />
    },
    {
      path: 'quanlykhuvuc',
      element: <QuanLyKhuVuc />
    },
    {
      path: 'nhapdulieucan',
      element: <NhapDuLieu />
    },
    {
      path: 'quanlyinphieu',
      element: <XuatDuLieu />
    },
    {
      path: 'quanlynguoidung',
      element: <QuanLyNguoiDung />
    }

  ]
};

export default MainRoutes;